import { render, staticRenderFns } from "./CreateAccount-1.vue?vue&type=template&id=b8e5edea"
import script from "./CreateAccount-1.vue?vue&type=script&lang=js"
export * from "./CreateAccount-1.vue?vue&type=script&lang=js"
import style0 from "./CreateAccount-1.vue?vue&type=style&index=0&id=b8e5edea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports